import React from 'react'
import { EmptyState, type Task } from 'prove-common'
import { TaskCard } from '../task-card/TaskCard'
import type { TaskDetails } from '../../utils/taskHelper'

export type TaskItem = {
  task: Task
  isCompleted: boolean
  details: TaskDetails
}

export type TaskListProps = {
  taskItems: TaskItem[]
  isFiltering: boolean
  onClick: (id: string) => void
}

export default function TaskList({
  taskItems,
  isFiltering,
  onClick
}: Readonly<TaskListProps>) {
  if (!taskItems.length)
    return (
      <EmptyState
        title={isFiltering ? 'Ingen treff' : 'Ingen oppgaver'}
        description={
          isFiltering
            ? 'Prøv andre filtervalg.'
            : 'Ingen oppgaver å vise for denne avdelingen.'
        }
      />
    )

  return taskItems.map((taskItem) => (
    <TaskCard
      key={taskItem.task.id}
      id={taskItem.task.id.toString()}
      details={taskItem.details}
      isGrouped={false}
      isCompleted={taskItem.isCompleted}
      onClick={onClick}
    />
  ))
}
